import React, { Component } from "react";
import { connect } from "react-redux";
import Current from "./Current";
// import { Link } from "react-router";
// import BacktestService from '../../service/backtest.service'

class Portfolio extends Component {
  state = {
    id: 0,
  };

  componentDidMount() {
    this.setState({ id: this.props.params.id });
  }

  render() {
    return (
      <div className="page-content" style={{ marginTop: "-100px" }}>
        {/* <div className="breadcrumbs">
					<h1>Portfolio</h1>
				    <ol className="breadcrumb">
				        <li>
				            <Link to={"/"}>Home</Link>
				        </li>
				        <li>
				            <Link to={"/create"}>Create Portfolio</Link>
				        </li>
				        <li className="active">Portfolio</li>
				    </ol>
					<button type="button" className="navbar-toggle" data-toggle="collapse" data-target=".page-sidebar">
						<span className="sr-only">Toggle navigation</span>
						<span className="toggle-icon">
							<span className="icon-bar"></span>
							<span className="icon-bar"></span>
							<span className="icon-bar"></span>
						</span>
					</button>
				</div> */}
        {/* error if portfolio creation fails */}
        {/* <Fragment>
					<div className="head-section">
					</div>
					<div className="page-body text-center">
						<h1>! Error in portfolio creation....</h1>
					</div>
				</Fragment> */}

        <Current id={this.state.id} />
      </div>
    );
  }
}

export default connect(
  (state) => ({}),
  (dispatch) => ({})
)(Portfolio);



// WEBPACK FOOTER //
// ./src/components/pages/Portfolio.jsx